<template>
<div class="panel">
    <div class="panel-title" id="create-account-panel">
        Pas encore inscrit ?
    </div>
    <div class="panel-content">
        <div class="row columns">
            <div class="large-7 large-centered columns">
                <router-link to="/createaccount"><button class="full-width">Je crée un compte</button></router-link>
            </div>
           <!--  <div class="large-6 columns">
                <button :disbaled="isFBLoaded" @click="facebookLogin" class="full-width text-centered">
                        connexion avec facebook
                </button>
           </div> -->
           <div id="fb-root"></div>
       </div>
   </div>
</div>
</template>

<script>

import auth from '../../api/auth.api'

export default {
  name: 'registerPanel',
  computed: {
    isFBLoaded () {
      if (window.FB) {
        return true
      }
      return false
    }
  },
  methods: {
    facebookLogin () {
      window.FB.getLoginStatus(response => {
        if (response.status === 'not_authorized') {
          window.FB.login(response => {
            if (response.status === 'connected') {
              auth.api.facebookLogin(response.authResponse.accessToken)
              .then(FBresponse => {
                console.log(FBresponse)
              },
              error => {
                console.log(error)
              })
            }
          })
          console.log(response)
        } else if (response.status === 'connected') {
          console.log(response.authResponse.accessToken)
          auth.api.facebookLogin(response.authResponse.accessToken)
          .then(FBresponse => {
            console.log(FBresponse)
          },
          error => {
            console.log(error)
          })
        }
      })
    }
  },
  data () {
    return {
      username: 'le gros beeeg'
    }
  }
}

</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
</style>



// WEBPACK FOOTER //
// register-panel.vue?19f5098c